import { mergeProps } from '@zag-js/solid';
import { createSplitProps } from '../../utils/create-split-props';
import { ark } from '../factory';
import { useTabsContext } from './use-tabs-context';
export const TabTrigger = (props) => {
    const [triggerProps, localProps] = createSplitProps()(props, ['disabled', 'value']);
    const api = useTabsContext();
    const mergedProps = mergeProps(() => api().getTriggerProps(triggerProps), localProps);
    return <ark.button {...mergedProps}/>;
};
